import React, { useEffect, useState } from 'react';
import {
  // Button,
  Dialog,
  // DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { useCommonStyles } from './styles';
import { useParams } from 'react-router';
import { aiInsights } from 'controllers/matchingDetails';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  dialogActionsContainer: {
    justifyContent: 'center',
    padding: 24,
  },
  generativeTextContainer: {
    width: 780,
    borderRadius: 8,
    background: (props) => (props.mode === 'dark' ? '#191826' : '#EFEFEF'),
    padding: 16,
    marginTop: 24,
    height: 500,
    overflow: 'none',
    overflowY: 'scroll',
  },
  insightsText: {
    fontWeight: 400,
    lineHeight: '28px',
  },
}));

const GenerativeText = ({
  generateText = false,
  text = '',
  setGenerating,
  mode,
}) => {
  const [generatedText, setGeneratedText] = useState('');
  const commonClasses = useCommonStyles({ mode });
  const classes = useStyles({ mode });

  useEffect(() => {
    let textInterval = null;
    let textMarker = 0;

    if (generateText && text) {
      const WORDS_COUNT_MAP = [1, 2, 3, 4, 5, 6, 7, 8];
      const splittedText = text.split(' ');

      textInterval = setInterval(() => {
        const count =
          WORDS_COUNT_MAP[Math.floor(Math.random() * WORDS_COUNT_MAP.length)];
        const prevTextMarker = textMarker;
        textMarker = textMarker + count;

        if (splittedText?.length <= prevTextMarker) {
          setGenerating(false);
          clearInterval(textInterval);
        }

        setGeneratedText(
          (prevText) =>
            `${prevText} ${splittedText
              .slice(prevTextMarker, textMarker)
              .join(' ')}`
        );
      }, 300);
    } else {
      if (textInterval) {
        clearInterval(textInterval);
      }
    }

    return () => {
      if (textInterval) {
        clearInterval(textInterval);
      }
    };
  }, [generateText, text, setGenerating]);
  return (
    <Grid container classes={{ root: classes.generativeTextContainer }}>
      <Grid xs={12}>
        <Typography
          dangerouslySetInnerHTML={{
            __html:
              generatedText.replace(/\n/g, '<br />') ||
              'Generating Insights...',
          }}
          classes={{
            root: clsx(commonClasses.fontRegular, classes.insightsText),
          }}
        />
      </Grid>
    </Grid>
  );
};

const MatchingDetailsInsights = ({
  title = '',
  isOpen = false,
  handleClose,
  ModalInsight,
  insightsText = '',
  mode,
}) => {
  // const classes = useStyles({ mode });
  const params = useParams();
  const commonClasses = useCommonStyles({ mode });
  const [generating, setGenerating] = useState(true);
  const [aiText, setAiText] = useState('');

  const fetchInsight = async () => {
    const PARAM_MAP = {
      'Work History': 'experience',
      Skills: 'skills',
      'Job Title': 'job_title',
    };
    if (!insightsText) {
      const response = await aiInsights(params.jobTalentId, PARAM_MAP[title]);
      setAiText(response?.response?.content || '');
      setGenerating(true);
    } else {
      setAiText(insightsText);
      setGenerating(true);
    }
  };

  useEffect(() => {
    fetchInsight();
    // eslint-disable-next-line
  }, []);

  // const handleRegenerate = async () => {
  //   if (generating) {
  //     setGenerating(false);
  //     return false;
  //   }
  //   const prevAiText = aiText;

  //   setAiText('');
  //   setGenerating(false);

  //   await new Promise(resolve => setTimeout(() => {resolve(true)}, 2000));

  //   setAiText(prevAiText);
  //   setGenerating(true);
  // }

  return (
    <Dialog
      maxWidth={'lg'}
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
    >
      <DialogTitle
        id="customized-dialog-title"
        onClose={handleClose}
        style={{ background: mode === 'dark' ? '#202133' : '#FFF' }}
      >
        <Typography classes={{ root: commonClasses.fontMediumBold }}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent
        dividers
        style={{ background: mode === 'dark' ? '#202133' : '#FFF' }}
      >
        <ModalInsight />
        <GenerativeText
          generateText={generating}
          setGenerating={setGenerating}
          text={aiText}
          mode={mode}
        />
      </DialogContent>
      {/* <DialogActions classes={{ root: classes.dialogActionsContainer }}>
        <Button onClick={handleRegenerate} color="primary">
          {generating ? "Stop Generations" : "Regenerate"}
        </Button>
      </DialogActions> */}
    </Dialog>
  );
};

export default MatchingDetailsInsights;
